<template>
    <div id="statistics">
		<v-row>
			<v-col>
				<v-navigation-drawer
					id="navigation-drawer"
					app
					width="200"
					:mobile-breakpoint="$vuetify.breakpoint.thresholds.lg"
					permanent
					clipped
					:right="$vuetify.rtl"
					light
					color="white"
   				>
					<v-autocomplete
						v-if="$route.name !== 'statistics-earnings-and-loss-chart'"
						v-model="financialFileId"
						:items="financialFiles"
						:label="$t('financial-file')"
						item-text="company_name"
						item-value="id"
						outlined
						hide-details
						dense
						:loading="loading"
						class="mx-2 my-2"
						@change="$router.replace({
							name: $route.name,
							query: { financialFileId: financialFileId }
						})"
					/>
					<p class="mx-3 mt-3 mb-3 primary--text">
						{{$t('Statistics.statistic-type')}}
					</p>
					<v-divider class="mx-3" />
					<v-list nav dense>
						<v-list-item-group>
							<!-- statistics -->
							<v-list-item
								:to="{
									name: 'statistics-final-accounts',
									query: financialFileId ? { financialFileId: financialFileId } : null
								}"
								:disabled="false"
								exact-path
							>
								<v-list-item-icon>
									<v-icon color="black">mdi-cash-register</v-icon>
								</v-list-item-icon>
								<v-list-item-title class="text-capitalize">
									{{$t('Statistics.final-accounts')}}
								</v-list-item-title>	
							</v-list-item>

							<!-- ملخص الإحضائيات -->
							<v-list-item
								:to="{
									name: 'statistics-custom-statements',
									query: financialFileId ? { financialFileId: financialFileId } : null
								}"
								:disabled="false"
								exact-path
							>
								<v-list-item-icon>
									<v-icon>mdi-badge-account-outline</v-icon>
								</v-list-item-icon>
								<v-list-item-title class="text-capitalize">
									{{$t('Statistics.custom-statements')}}
								</v-list-item-title>	
							</v-list-item>

							<v-list-item
								:to="{ name: 'statistics-account-summary' }"
								disabled
								exact-path
							>
								<v-list-item-icon>
									<v-icon>mdi-clipboard-text-search-outline</v-icon>
								</v-list-item-icon>
								<v-list-item-title>
									{{$t('Statistics.accounts-summary')}}
								</v-list-item-title>	
							</v-list-item>

							<v-list-item
								:to="{ name: 'statistics-earnings-and-loss-chart' }"
								disabled
								exact-path
							>
								<v-list-item-icon>
									<v-icon> mdi-finance </v-icon>
								</v-list-item-icon>
								<v-list-item-title>
									{{$t('Statistics.earnings-and-loss-chart')}}
								</v-list-item-title>	
							</v-list-item>

						</v-list-item-group>
					</v-list>
   	 			</v-navigation-drawer>
			</v-col>
		</v-row>
		<router-view/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Statistics',
	data() {
		return {
			loading: false,

			financialFileId: null,
		}
	},
	computed: {
		...mapState({
			financialFiles: state => state.financialFiles.financial_files
		})
	},
	created() {
		if (!this.financialFiles.length) {
			this.loading = true;
			this.$store.dispatch('financialFiles/fetchAll', {}).finally(() => {
				this.loading = false;
			});
		}
		if (this.$route.query.financialFileId) {
			this.financialFileId = +this.$route.query.financialFileId;
		}
	}
}
</script>

<style>
#statistics .fixed-header thead.v-data-table-header {
	right: unset;
	left: unset;
}

</style>